import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrganizationPhone} from '../organization/organization-phone';
import {GoogleService} from './google-service';

@Service()
export class OrganizationPhoneService {
  private readonly googleService = inject(GoogleService);
  private readonly http = inject(HttpClient);


  private urlBase = environment.serviceUrl;

  public getOrganizationPhones(organizationId: string): Observable<OrganizationPhone[]> {
    let url = this.urlBase + 'phones/organization/' + organizationId;
    return this.http.get<OrganizationPhone[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public deletePhone(phone: OrganizationPhone): Observable<string> {
    let url = this.urlBase + 'phones/' + phone.orgUnitId + "/" + phone.phoneNumber;
    return this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  public save(phone: OrganizationPhone): Observable<string> {
    let url = this.urlBase + 'phones/save';
    let body = JSON.stringify(phone);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
